import { useEffect } from 'react';

import { ICredentialForm } from '@givebacks/api/core';
import { atom, useSetAtom } from 'jotai';

type TokenizeCallback = Record<'fn', (() => Promise<unknown>) | null>;
const TokenizeCvvOnlyAtom = atom<TokenizeCallback>({ fn: null });

const setTokenizeCvvCallbackAtom = atom(null, (_, set, cbFn: TokenizeCallback) => {
  set(TokenizeCvvOnlyAtom, cbFn);
});
const TokenizeCvOnlyAtom = atom(TokenizeCvvOnlyAtom, async (get) => {
  const { fn } = get(TokenizeCvvOnlyAtom);
  const value = (await fn?.()) as ICredentialForm;
  return value;
});

const useTokenize = ({ tokenizeCard }: { tokenizeCard?: () => Promise<unknown> } = {}) => {
  const setTokenizeCallback = useSetAtom(setTokenizeCvvCallbackAtom);
  const getTokenizedCard = useSetAtom(TokenizeCvOnlyAtom);

  useEffect(() => {
    const getToken = async () => {
      const token = await tokenizeCard?.();
      return token;
    };
    setTokenizeCallback({ fn: getToken });

    return () => {
      setTokenizeCallback({ fn: null });
    };
  }, [tokenizeCard]);

  return {
    getCvvTokenForm: getTokenizedCard,
    getTokenizedCard,
  };
};

export { useTokenize };
